export interface Obj {
  [propName: string]: any;
}

declare global {
  interface Window {
    chrome: any;
    showModalDialog: any;
  }
}

class UA {
  [key: string]: any;
}

export default class UserAgent extends UA {
  static version = '1.0.0';
  navigator = typeof window.navigator !== 'undefined' ? window.navigator : {} as Obj;
  userAgent = window.navigator.userAgent || '';
  constants = {
    engine: ['WebKit', 'Trident', 'Gecko'],
    browser: [
      'Safari', 'Chrome', 'Firefox', 'Firefox Focus', 'Chromium', 'Opera',
      'Edg', 'Edge', 'IE',
      '360', '360SE', '360EE',
      'UC', 'QQBrowser', 'QQ', 'Baidu', 'Maxthon', 'Sogou', 'LBBROWSER',
      'Qaxbrowser', // 国产环境
      'MicroMessenger', 'wxwork', // 微信、企业微信
      'DingTalk', 'EMobile',// 钉钉、EMobile
      'Weapp', 'WeappPC',
      'Welink',
      'YunZhiJia',
      'Lark',
      // 'ZheZhengTing',
      'ZhengWuDing',
      'miniProgram',
    ],
    os: ['Windows', 'Linux', 'Mac OS', 'Android', 'Ubuntu', 'FreeBSD', 'Debian', 'iOS', 'Windows Phone', 'Chrome OS'],
    device: ['Mobile', 'Tablet'],
  } as Obj;
  device = 'PC';
  engine = '';
  browser = '';
  os = '';

  constructor (userAgent?: string) {
    super();
    if (userAgent) {
      this.userAgent = userAgent;
    }
    this.init();
  }

  get language () {
    const g = this.navigator.browserLanguage || this.navigator.language;
    const arr = g.split('-');
    if (arr[1]) {
      arr[1] = arr[1].toUpperCase();
    }
    return arr.join('_');
  }

  get version () {
    const u = this.userAgent;
    const map = {
      'Safari': () => {
        return u.replace(/^.*Version\/([\d.]+).*$/, '$1');
      },
      'Chrome': () => {
        return u.replace(/^.*Chrome\/([\d.]+).*$/, '$1').replace(/^.*CriOS\/([\d.]+).*$/, '$1');
      },
      'Firefox': () => {
        return u.replace(/^.*Firefox\/([\d.]+).*$/, '$1').replace(/^.*FxiOS\/([\d.]+).*$/, '$1');
      },
      'Firefox Focus': () => {
        return u.replace(/^.*Focus\/([\d.]+).*$/, '$1');
      },
      'Chromium': () => {
        return u.replace(/^.*Chromium\/([\d.]+).*$/, '$1');
      },
      'Opera': () => {
        return u.replace(/^.*Opera\/([\d.]+).*$/, '$1').replace(/^.*OPR\/([\d.]+).*$/, '$1');
      },
      'IE': () => {
        return u.replace(/^.*MSIE ([\d.]+).*$/, '$1').replace(/^.*rv:([\d.]+).*$/, '$1');
      },
      'Edg': () => {
        return u.replace(/^.*Edg\/([\d.]+).*$/, '$1');
      },
      'Edge': () => {
        return u.replace(/^.*Edge\/([\d.]+).*$/, '$1');
      },
      '360': () => {
        return u.replace(/^.*QihooBrowser\/([\d.]+).*$/, '$1');
      },
      '360SE': () => {
        const hash = { '63': '10.0', '55': '9.1', '45': '8.1', '42': '8.0', '31': '7.0', '21': '6.3' } as Obj;
        const chromeVision = u.replace(/^.*Chrome\/([\d]+).*$/, '$1');
        return hash[chromeVision] || '';
      },
      '360EE': () => {
        const hash = { '69': '11.0', '63': '9.5', '55': '9.0', '50': '8.7', '30': '7.5' } as Obj;
        const chromeVision = u.replace(/^.*Chrome\/([\d]+).*$/, '$1');
        return hash[chromeVision] || '';
      },
      'QQBrowser': () => {
        return u.replace(/^.*QQBrowser\/([\d.]+).*$/, '$1');
      },
      'QQ': () => {
        return u.replace(/^.*QQ\/([\d.]+).*$/, '$1');
      },
      'Baidu': () => {
        return u.replace(/^.*BIDUBrowser[\s/]([\d.]+).*$/, '$1');
      },
      'UC': () => {
        return u.replace(/^.*UC?Browser\/([\d.]+).*$/, '$1');
      },
      'Sogou': () => {
        return u.replace(/^.*SE ([\d.X]+).*$/, '$1').replace(/^.*SogouMobileBrowser\/([\d.]+).*$/, '$1');
      },
      'LBBROWSER': () => {
        const hash = { '57': '6.5', '49': '6.0', '46': '5.9', '42': '5.3', '39': '5.2', '34': '5.0',
          '29': '4.5', '21': '4.0' } as Obj;
        const chromeVision = window.navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/, '$1');
        return hash[chromeVision] || '';
      },
      'Qaxbrowser': () => {
        return u.replace(/^.*Qaxbrowser\/([\d.]+).*$/, '$1');
      },
      'wxwork': () => {
        return u.replace(/^.*wxwork\/([\d.]+).*$/, '$1');
      },
      'MicroMessenger': () => {
        return u.replace(/^.*MicroMessenger\/([\d.]+).*$/, '$1');
      },
      'DingTalk': () => {
        const mVersion = u.replace(/^.*AliApp\(DingTalk\/([\d.]+).*$/, '$1');
        const pcVersion = u.replace(/^.*DingTalk\(([\d.]+).*$/, '$1');
        return this.device === 'Mobile' ? mVersion : pcVersion;
      },
      'EMobile': () => {
        return u.replace(/^.*E-Mobile\d+\/([\d.]+).*$/, '$1');
      },
      'Weapp': () => {
        return /.*weapp\/([\d.]+).*$/.test(u) ? RegExp.$1: null;
      },
      'WeappPC': () => {
        return /.*weapp-pc\/([\d.]+).*$/.test(u) ? RegExp.$1: null;
      },
      'Lark': () => {
        return u.replace(/^.*Lark.*$/, '$1');
      },
      'YunZhiJia': () => {
        return u.replace(/^.*Qing\/([\d.]+).*$/, '$1');
      },
      // 'ZheZhengTing': () => {
      //   return u.replace(/^.*Nebula TaurusApp.*$/, '$1');
      // },
      'ZhengWuDing': () => {
        return u.replace(/^.*TaurusApp.*$/, '$1');
      },
      'Welink': () => {
        return u.replace(/^.*welink.*$/, '$1').replace(/^.*cloudlink.*$/, '$1');
      },
    } as Obj;
    const fn = map[this.browser];
    let version = '';
    if (typeof fn === 'function') {
      version = fn();
    }
    return version === u ? '' : version;
  }

  get osVersion () {
    const u = this.userAgent;
    const map = {
      'Windows': () => {
        const v = u.replace(/^.*Windows NT ([\d.]+);.*$/, '$1');
        const hash = {
          '6.4': '10',
          '6.3': '8.1',
          '6.2': '8',
          '6.1': '7',
          '6.0': 'Vista',
          '5.2': 'XP',
          '5.1': 'XP',
          '5.0': '2000',
        } as Obj;
        return hash[v] || v;
      },
      'Android': () => {
        return u.replace(/^.*Android ([\d.]+);.*$/, '$1');
      },
      'iOS': () => {
        return u.replace(/^.*OS ([\d_]+) like.*$/, '$1').replace(/_/g, '.');
      },
      'Debian': () => {
        return u.replace(/^.*Debian\/([\d.]+).*$/, '$1');
      },
      'Windows Phone': () => {
        return u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/, '$2');
      },
      'Mac OS': () => {
        return u.replace(/^.*Mac OS X ([\d_]+).*$/, '$1').replace(/_/g, '.');
      },
      'WebOS': () => {
        return u.replace(/^.*hpwOS\/([\d.]+);.*$/, '$1');
      },
    } as Obj;
    const fn = map[this.os];
    let osVersion = '';
    if (typeof fn === 'function') {
      osVersion = fn();
    }
    return osVersion === u ? '' : osVersion;
  }

  init = () => {
    Object.keys(this.constants).forEach(key => {
      this.constants[key].forEach((constant: string) => {
        if (this.match()[constant]) {
          this[key] = constant;
        }
      });
    });
    if (this.browser === 'Edg') {
      this.engine = 'Edge(Chromium)';
    } else if (this.browser === 'Edge') {
      this.engine = 'EdgeHTML';
    } else if (this.browser === 'Chrome' && parseInt(this.version, 10) > 27) {
      this.engine = 'Blink';
    } else if (this.browser === 'Opera' && parseInt(this.version, 10) > 12) {
      this.engine = 'Blink';
    } else if (this.browser === 'Yandex') {
      this.engine = 'Blink';
    }
  }

  mime = (option: string, value: string) => {
    const mimeTypes = this.navigator.mimeTypes;
    for (const mt in mimeTypes) {
      if (mimeTypes[mt][option] === value) {
        return true;
      }
    }
    return false;
  }

  match = () => {
    const u = this.userAgent;
    const m = {
      // engine
      'Trident': u.indexOf('Trident') > -1 || u.indexOf('NET CLR') > -1,
      'WebKit': u.indexOf('AppleWebKit') > -1,
      'Gecko': u.indexOf('Gecko/') > -1,
      // browser
      'Safari': u.indexOf('Safari') > -1,
      'Chrome': u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1,
      'IE': u.indexOf('MSIE') > -1 || u.indexOf('Trident') > -1,
      'Edg': u.indexOf('Edg') > -1,
      'Edge': u.indexOf('Edge') > -1,
      'Firefox': u.indexOf('Firefox') > -1 || u.indexOf('FxiOS') > -1,
      'Firefox Focus': u.indexOf('Focus') > -1,
      'Chromium': u.indexOf('Chromium') > -1,
      'Opera': u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1,
      '360': u.indexOf('QihooBrowser') > -1 || u.indexOf('QHBrowser') > -1,
      '360EE': u.indexOf('360EE') > -1,
      '360SE': u.indexOf('360SE') > -1,
      'UC': u.indexOf('UC') > -1 || u.indexOf(' UBrowser') > -1,
      'QQBrowser': u.indexOf('QQBrowser') > -1 && !(u.indexOf('MSIE') > -1 || u.indexOf('Trident') > -1),
      'QQ': u.indexOf('QQ/') > -1,
      'Baidu': u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1,
      'Maxthon': u.indexOf('Maxthon') > -1,
      'Sogou': u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1,
      'LBBROWSER': u.indexOf('LBBROWSER') > -1,
      'Qaxbrowser': u.indexOf('Qaxbrowser') > -1,
      'wxwork': u.indexOf('wxwork') > -1,
      'MicroMessenger': u.indexOf('MicroMessenger') > -1,
      'DingTalk': u.indexOf('DingTalk') > -1,
      'EMobile': u.indexOf('E-Mobile') > -1,
      'Weapp': u.indexOf('weapp') > -1,
      'WeappPC': u.indexOf('weapp-pc') > -1,
      'Lark': u.indexOf('Lark') > -1,
      'YunZhiJia': u.indexOf('Qing') > -1,
      'Welink': u.indexOf('welink') > -1 || u.indexOf('cloudlink') > -1,
      // 'ZheZhengTing': u.indexOf('Nebula TaurusApp') > -1,
      'ZhengWuDing': u.indexOf('TaurusApp') > -1,
      // os
      'Windows': u.indexOf('Windows') > -1,
      'Linux': u.indexOf('Linux') > -1 || u.indexOf('X11') > -1,
      'Mac OS': u.indexOf('Macintosh') > -1,
      'Android': u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
      'Ubuntu': u.indexOf('Ubuntu') > -1,
      'FreeBSD': u.indexOf('FreeBSD') > -1,
      'Debian': u.indexOf('Debian') > -1,
      'Windows Phone': u.indexOf('IEMobile') > -1 || u.indexOf('Windows Phone') > -1,
      'iOS': u.indexOf('like Mac OS X') > -1,
      'Chrome OS': u.indexOf('CrOS') > -1,
      // device
      'Mobile': (u.indexOf('Mobi') > -1 && u.indexOf('weapp-pc') < 0) || u.indexOf('iPh') > -1 || u.indexOf('480') > -1  || u.indexOf('MQQBrowser') > -1,
      // no.2259901 判断规则  1.判断当前设备是否为安卓设备 2.如果为安卓设备情况下 并且 是 【weapp】 应用 3. 判断userAgent 是否包含【Mobile】 如果不包含 即为大屏设备
      'Tablet': (u.indexOf('Tablet') > -1 && u.indexOf('Tablet PC') < 0) || u.indexOf('Pad') > -1 || u.indexOf('Nexus 7') > -1 || (u.indexOf('Android') > -1 && u.indexOf('weapp') > -1 && u.indexOf('weapp-pc') < 0 && u.indexOf('Mobi') < 0),
      'miniProgram': u.indexOf('miniProgram') > -1,
    } as Obj;
    let is360 = false;
    if (window.chrome) {
      const chromeVision = Number(u.replace(/^.*Chrome\/([\d]+).*$/, '$1'));
      if (chromeVision > 36 && window.showModalDialog) {
        is360 = true;
      } else if (chromeVision > 45) {
        is360 = this.mime('type', 'application/vnd.chromium.remoting-viewer');
      }
    }
    if (m.Mobile) {
      m.Mobile = !(u.indexOf('iPad') > -1);
    } else if (is360) {
      if (this.mime('type', 'application/gameplugin')) {
        m['360SE'] = true;
      } else if (this.navigator
        && this.navigator.connection
        && typeof this.navigator.connection.saveData === 'undefined') {
        m['360SE'] = true;
      } else {
        m['360EE'] = true;
      }
    }
    if (m.IE || m.Edge) {
      const navigatorTop = window.screenTop - window.screenY;
      switch (navigatorTop) {
        case 71: // 无收藏栏,贴边
        case 99: // 有收藏栏,贴边
        case 102: // 有收藏栏,非贴边
          m['360EE'] = true;
          break;
        case 75: // 无收藏栏,贴边
        case 74: // 无收藏栏,非贴边
        case 105: // 有收藏栏,贴边
        case 104: // 有收藏栏,非贴边
          m['360SE'] = true;
          break;
        default:
          break;
      }
    }
    if (m.Baidu && m.Opera) {
      m.Baidu = false;
    }
    return m;
  }
}

const uaa = new UserAgent();

export type UAType = Readonly<Pick<UserAgent, 'device' | 'engine' | 'browser' | 'os' | 'osVersion' | 'version' | 'language'>>;

export const ua: UAType = {
  device: uaa.device,
  engine: uaa.engine,
  browser: uaa.browser,
  os: uaa.os,
  osVersion: uaa.osVersion,
  version: uaa.version,
  language: uaa.language,
};

